import DotsLoading from '../../../components/dotsLoading';
import SuggestProductCard from '../../../pages/farm/productDetail/SuggestProductCard';
import useGetSuggestAdvertisement from '../../../services/hookService/getSuggestAdvertisement/useGetSuggestAdvertisement.tsx';

const SimilarProducts = ({subBrandId}: {subBrandId: number}) => {
  const {data, isLoading} = useGetSuggestAdvertisement(subBrandId);

  if (!Boolean(data?.length)) return null;

  return (
    <div className="flex flex-col w-full gap-2 p-4 -mt-8">
      <div className="flex items-center justify-between w-full text-md">
        <h5 className="flex items-center text-gray-700 text-md">
          محصولات مشابه
        </h5>
      </div>

      <div className="flex items-center w-full gap-4 pb-3 mb-6 overflow-x-auto">
        {isLoading ? (
          <div className="flex items-center justify-center w-full h-full my-3">
            <DotsLoading />
          </div>
        ) : (
          data?.map(item => <SuggestProductCard key={item.id} item={item} />)
        )}
      </div>
    </div>
  );
};

export default SimilarProducts;
